module.exports = __webpack_public_path__ + "img/tiantianshenghuo.8c237b75.png";